"use strict";
export const WALLET_CONNECT_STORAGE_PREFIX = "topaz";
const WALLET_CONNECT_KEY_PREFIX = "wc@2:";
const PREFIXED_KEY_MARKERS = [`:${WALLET_CONNECT_STORAGE_PREFIX}//`, `:${WALLET_CONNECT_STORAGE_PREFIX}:`];
export const LEGACY_PURGE_FLAG = "topaz.legacyWcStoragePurged.v1";
const WALLET_CONNECT_DB_NAME = "WALLET_CONNECT_V2_INDEXED_DB";
const WALLET_CONNECT_STORE_NAME = "keyvaluestorage";
export function isLegacyWalletConnectKey(key) {
  return typeof key === "string" && key.startsWith(WALLET_CONNECT_KEY_PREFIX) && !PREFIXED_KEY_MARKERS.some((marker) => key.includes(marker));
}
export function purgeLegacyWalletConnectLocalStorage(storage) {
  const removed = [];
  for (let index = storage.length - 1; index >= 0; index--) {
    const key = storage.key(index);
    if (isLegacyWalletConnectKey(key)) {
      storage.removeItem(key);
      removed.push(key);
    }
  }
  return removed;
}
function settle(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
function openExistingDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(WALLET_CONNECT_DB_NAME);
    let created = false;
    request.onupgradeneeded = () => {
      created = true;
      request.transaction?.abort();
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => created ? resolve(void 0) : reject(request.error);
    request.onblocked = () => resolve(void 0);
  });
}
export async function purgeLegacyWalletConnectIndexedDb() {
  if (typeof indexedDB === "undefined") {
    return [];
  }
  const db = await openExistingDatabase();
  if (!db) {
    return [];
  }
  try {
    if (!db.objectStoreNames.contains(WALLET_CONNECT_STORE_NAME)) {
      return [];
    }
    const transaction = db.transaction(WALLET_CONNECT_STORE_NAME, "readwrite");
    const done = new Promise((resolve, reject) => {
      transaction.oncomplete = () => resolve();
      transaction.onerror = () => reject(transaction.error);
      transaction.onabort = () => reject(transaction.error);
    });
    const store = transaction.objectStore(WALLET_CONNECT_STORE_NAME);
    const legacyKeys = (await settle(store.getAllKeys())).filter(isLegacyWalletConnectKey);
    legacyKeys.forEach((key) => store.delete(key));
    await done;
    return legacyKeys;
  } finally {
    db.close();
  }
}
export async function purgeLegacyWalletConnectStorage(storage) {
  try {
    if (storage.getItem(LEGACY_PURGE_FLAG)) {
      return [];
    }
    const removed = purgeLegacyWalletConnectLocalStorage(storage);
    removed.push(...await purgeLegacyWalletConnectIndexedDb());
    storage.setItem(LEGACY_PURGE_FLAG, "1");
    return removed;
  } catch (error) {
    console.warn("WalletConnect legacy storage purge skipped", error);
    return [];
  }
}
